import React from 'react';
import Helmet from 'react-helmet';
import { graphql } from 'gatsby';
import get from 'lodash/get';
import Formwizard from '../../components/Formwizard';
import KnownFromLegacy from '../../components/KnownFromLegacy';
import SEO from '../../components/SEO';
import Link from '../../components/Link';
import { EVENT_OBJECT, EVENT_VERB, eventBuilder } from '../../utils/tracking';

const BewertungAnfordernLp = ({ data, location }) => {
  const page = get(data, 'contentfulPage');

  return (
    <div>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="/legacy/oldlegacylayout.css"
        />
      </Helmet>
      <SEO
        entity={page}
        title={page.metaTitle || page.title}
        canonical={page.canonical}
        type="page"
        description={page.metaDescription}
        indexable={page.indexable}
      />
      <Helmet bodyAttributes={{ class: 'oldlegacy' }} />
      <header>
        <nav
          className="navbar navbar-expand-lg navbar-light px-0 py-1 py-lg-2 shadow"
          style={{ background: '#0078be' }}
        >
          <div className="container-fluid justify-content-center justify-content-md-start flex-column flex-md-row ml-lg-6 ml-xl-7">
            <div className="d-block navbar-brand mr-0 mr-md-2 pb-0 pt-0 py-md-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={150}
                height={21}
                className="logo"
                viewBox="0 0 134 18"
              >
                <defs>
                  <style
                    dangerouslySetInnerHTML={{
                      __html: '\n      .a{fill:#ffffff}\n    ',
                    }}
                  />
                </defs>
                <path
                  className="a"
                  d="M133.45 5.5a9.8 9.8 0 01.06 6.38 7.95 7.95 0 01-4.29 4.81 8.8 8.8 0 01-3.76.75h-6.6V.01h6.6c1.4 0 2.64.25 3.71.75a7.92 7.92 0 014.28 4.75zm-4.27 4.9a5.94 5.94 0 00-.01-3.37 3.9 3.9 0 00-2.03-2.49 3.74 3.74 0 00-1.75-.39h-2v9.16h2a3.77 3.77 0 003.04-1.44c.35-.44.6-.94.76-1.47h-.01zM110.4.01h-4.53v17.43h10.81V13.3h-6.28zM103.86 5.04c.5 1.13.75 2.44.75 3.94a9.8 9.8 0 01-.65 3.64 8.3 8.3 0 01-1.83 2.83c-.8.8-1.76 1.43-2.81 1.84a10.2 10.2 0 01-6.9.11 7.92 7.92 0 01-4.79-4.47 9.8 9.8 0 01-.74-3.95c0-1.5.26-2.82.77-3.94A8.19 8.19 0 0192.52.57a9.9 9.9 0 016.52 0 8.22 8.22 0 014.82 4.47zm-4.14 5.98c.27-.65.4-1.34.38-2.04.01-.7-.11-1.39-.37-2.04a4.37 4.37 0 00-.98-1.45c-.39-.38-.85-.68-1.37-.87a4.48 4.48 0 00-1.56-.28c-.56 0-1.11.09-1.64.27-.52.18-1 .47-1.4.86-.43.4-.77.9-1 1.45-.25.65-.38 1.36-.37 2.06-.01.7.11 1.39.37 2.04a4.07 4.07 0 002.36 2.33 4.48 4.48 0 003.21 0 4.08 4.08 0 002.37-2.33zM76.82 7.8v3.9h3.76a3.7 3.7 0 01-1.55 1.73c-.6.32-1.36.47-2.27.47-.63.01-1.25-.11-1.83-.36-.53-.22-1-.57-1.38-1a4.64 4.64 0 01-.88-1.54 6.07 6.07 0 01-.32-2.02c0-.65.1-1.3.3-1.93.17-.57.46-1.11.84-1.58a4.04 4.04 0 013.27-1.5c.85 0 1.57.14 2.15.44.58.3 1.07.8 1.47 1.52h4.35s-.58-1.83-1.15-2.65A7.26 7.26 0 0079.36.36a9.65 9.65 0 00-5.8.22 8.24 8.24 0 00-4.88 4.5 9.41 9.41 0 00-.76 3.93c0 1.49.25 2.8.76 3.91a8.26 8.26 0 004.88 4.47 9.73 9.73 0 005.62.28 8.13 8.13 0 002.21-.9 7.12 7.12 0 003.14-3.91c.27-.82.44-1.66.5-2.52.04-.85.03-1.7-.04-2.53h-8.17zm-12.86.45c-.66-.4-1.4-.7-2.15-.84-.86-.18-1.72-.3-2.58-.38a7.18 7.18 0 01-1.92-.4c-.45-.18-.68-.56-.68-1.14-.01-.28.06-.56.22-.8.14-.2.33-.35.55-.45.24-.11.5-.19.75-.22.26-.04.51-.06.77-.06.56-.02 1.1.12 1.6.39.46.26.7.68.71 1.27h4.21A4.93 4.93 0 0063.4 1.4 6.5 6.5 0 0061.28.35a9.1 9.1 0 00-4.96 0c-.77.22-1.49.57-2.13 1.04a5.15 5.15 0 00-2.02 4.21c0 .9.18 1.67.54 2.28.35.61.83 1.13 1.42 1.51.62.4 1.3.7 2.01.86.76.2 1.53.31 2.31.36.31.02.65.04 1.02.08.35.03.7.1 1.03.23.3.11.57.3.8.53.2.23.31.55.31.96 0 .25-.07.5-.23.7-.17.2-.37.37-.6.5a4.18 4.18 0 01-3.68-.01 1.9 1.9 0 01-.61-.56c-.16-.23-.24-.5-.23-.78h-4.32a4.98 4.98 0 002.15 4.3c.7.48 1.46.83 2.28 1.03a10.53 10.53 0 005.26 0 7.3 7.3 0 002.28-1.02 5.32 5.32 0 001.6-1.72c.42-.73.63-1.57.61-2.4 0-1.07-.18-1.93-.55-2.6a4.37 4.37 0 00-1.51-1.6h-.1zM45.4 11.56a1.84 1.84 0 01-.8 1.57c-.23.17-.5.3-.8.37a3.39 3.39 0 01-1.84 0c-.29-.07-.56-.2-.8-.37a1.84 1.84 0 01-.8-1.56V0h-4.4v11.65a5.43 5.43 0 002.14 4.45c.68.5 1.43.89 2.24 1.13 1.7.51 3.53.51 5.23 0 .8-.24 1.56-.62 2.23-1.13a5.4 5.4 0 002.12-4.44V0H45.4v11.55zM28.7 13.62a27.45 27.45 0 01-4.73 3.23h10.78s-.92-3.2-2.3-6.85c-1.2 1.31-1.88 2.14-3.75 3.62z"
                />
                <path
                  d="M15.98 17.4S20.53.01 25 .01c1.73 0 3.63 3.09 5.24 6.67-3.2 3.93-9 8.42-12.7 10.72h-1.56z"
                  fill="#f46364"
                />
                <path
                  className="a"
                  d="M9.93 6.28h-5.4V.01H0v17.3h4.53v-6.89h5.4v7.02h4.53V.01H9.93z"
                />
              </svg>
            </div>
            <div className="d-block ml-md-7 ml-xl-7 text-center">
              <Link
                className="text-white"
                to="tel:+494022616140"
                eventLabel="Kostenlose Telefonberatung: 040 - 22 61 61 40"
                eventName={eventBuilder(
                  EVENT_OBJECT.headerLink,
                  EVENT_VERB.interacted
                )}
              >
                <small
                  className="text-uppercase small"
                  style={{ fontSize: '0.7rem' }}
                >
                  Kostenlose Telefonberatung:
                </small>
                <br />
                <strong
                  className="d-block h3 mb-0 font-weight-semibold pt-0"
                  style={{
                    marginTop: '-2px',
                    textDecoration: 'underline',
                    fontSize: '1rem',
                  }}
                >
                  040 - 22 61 61 40
                </strong>
              </Link>
            </div>
          </div>
        </nav>
      </header>
      <div className="container-md p-0 ml-0 mr-0">
        <div className="row m-0">
          <div className="oldlegacy formwizard col-12 col-sm-12 col-md-10 col-lg-9 col-xl-10 mt-0 mt-lg-4 ml-lg-6 ml-xl-7 p-0">
            <div className="card shadow rounded-0">
              <div className="card-header bg-none pt-2 pt-md-5 pl-md-6 pl-0 rounded-0 position-relative">
                <h1 className="d-none d-md-block pb-0 mb-1 text-center text-md-left mt-3">
                  Was ist meine Immobilie wert?
                </h1>
                <h3 className="d-block d-md-none text-center m-0 mb-1">
                  Was ist meine Immobilie wert?
                </h3>
                <h2 className="font-weight-light pt-md-1 pt-0 px-3 px-md-0 text-center text-md-left mb-3">
                  Jetzt kostenlose Bewertung für den Verkauf sichern!
                </h2>
              </div>
              <div
                className="card-body m-0 p-0"
                style={{ marginTop: '-15px!important' }}
              >
                <Formwizard
                  position="header"
                  location={location}
                  url="https://formwizard.hausgold.de/formular/wert-ermitteln"
                />
              </div>
              <div
                className="card-footer p-0"
                style={{ background: '#fafbff' }}
              >
                <ul className="d-block d-md-flex list-inline icon-list icon-list-lg m-0 justify-content-between p-4">
                  <li className="list-inline-item d-block d-md-inline-block mb-3 mb-md-0">
                    <svg
                      style={{ width: '50px', height: '50px' }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#5CA011"
                        d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
                      />
                    </svg>
                    <small className="text-muted font-weight-semibold">
                      In wenigen Schritten Angaben zur Immobilie machen
                    </small>
                  </li>
                  <li className="list-inline-item d-block d-md-inline-block mb-3 mb-md-0">
                    <svg
                      style={{ width: '50px', height: '50px' }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#5CA011"
                        d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
                      />
                    </svg>
                    <small className="text-muted font-weight-semibold">
                      Einfach und unverbindlich Kontaktformular ausfüllen
                    </small>
                  </li>
                  <li className="list-inline-item d-block d-md-inline-block mb-3 mb-md-0">
                    <svg
                      style={{ width: '50px', height: '50px' }}
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="#5CA011"
                        d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
                      />
                    </svg>
                    <small className="text-muted font-weight-semibold">
                      Kostenlose Immobilienbewertung durch Experten vor Ort
                      sichern
                    </small>
                  </li>
                </ul>
                <div className="bottom bg-primary">
                  <div className="container">
                    <div className="row text-white pt-3">
                      <div className="col-12 col-md-4">
                        <strong className="border-bottom border-white d-block">
                          Kundenbewertung
                        </strong>
                        <blockquote className="pt-3">
                          <div className="rating d-inline-block">
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                          </div>
                          <p className="d-inline-block float-right font-italic old pt-2">
                            Karl W.
                          </p>
                          <p className="font-weight-light old pt-1">
                            Professionelle Arbeit seitens des bestellten
                            Maklers, zügige Bearbeitung. Sehr ordentliche
                            Vorgehensweise!
                          </p>
                        </blockquote>
                        <blockquote>
                          <div className="rating d-inline-block">
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                          </div>
                          <p className="d-inline-block float-right font-italic old pt-2">
                            Paul H.
                          </p>
                          <p className="font-weight-light old pt-1">
                            Sehr sachliche und kompetente Beratung. Zügige
                            Vermittlung. Note sehr gut!!!
                          </p>
                        </blockquote>
                        <blockquote>
                          <div className="rating d-inline-block">
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                            <svg
                              width={19}
                              height={19}
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20.5 7.33l-5.46 4.54 1.64 6.73-6.18-3.57-6.18 3.57 1.63-6.73L.5 7.33l7.19-.58L10.5.4l2.81 6.35z"
                                fill="yellow"
                                fillRule="nonzero"
                              />
                            </svg>
                          </div>
                          <p className="d-inline-block float-right font-italic old pt-2">
                            Horst M.
                          </p>
                          <p className="font-weight-light old pt-1">
                            Mit der Bewertung des Hauses und dem Auftreten des
                            Maklers waren wir sehr zufrieden.
                          </p>
                        </blockquote>
                      </div>
                      <KnownFromLegacy />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Custom footer in white */}
      <footer className="oldlegacy formwizard col-12 col-sm-12 col-md-10 col-lg-9 col-xl-10 mt-0 mt-lg-4 ml-lg-6 ml-xl-7 p-0">
        <div className="text-center bg-white">
          <ul className="list-inline">
            <li className="list-inline-item mr-3">
              <Link
                className="text-muted"
                to="https://www.hausgold.de/hilfeundfaq/"
                eventLabel="Hilfe & FAQ"
              >
                Hilfe &amp; FAQ
              </Link>
            </li>
            <li className="list-inline-item mr-3">
              <Link
                className="text-muted"
                to="https://www.hausgold.de/kontakt/"
                eventLabel="Kontakt"
              >
                Kontakt
              </Link>
            </li>
            <li className="list-inline-item mr-3">
              <Link
                className="text-muted"
                to="https://www.hausgold.de/datenschutz/"
                eventLabel="Datenschutz"
              >
                Datenschutz
              </Link>
            </li>
            <li className="list-inline-item mr-3">
              <Link
                className="text-muted"
                to="https://www.hausgold.de/agb/"
                eventLabel="AGB"
              >
                AGB
              </Link>
            </li>
            <li className="list-inline-item mr-3">
              <Link
                className="text-muted"
                to="https://www.hausgold.de/impressum/"
                eventLabel="Impressum"
              >
                Impressum
              </Link>
            </li>
            <li className="list-inline-item text-muted">© 2020 Hausgold</li>
          </ul>
          <small className="text-muted" id="press-release-dates">
            <sup>1</sup>Tagesspiegel: 05.2015, Die Welt: 05.2015, Klassik Radio:
            09.2021, ImmobilienZeitung: 04.2021, Hamburger Abendblatt: 02.2015,
            FAZ: 05.2020, ZDF: 02.2020
          </small>
        </div>
      </footer>
    </div>
  );
};

export default BewertungAnfordernLp;

export const pageQuery = graphql`
  query bewertungAnfordernQuery {
    site {
      siteMetadata {
        title
      }
    }
    contentfulPage(
      slug: { eq: "bewertung-anfordern" }
      template: { eq: "Landingpage" }
    ) {
      id
      title
      headline
      metaTitle
      metaDescription
      subTitle
      canonical
      indexable
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
